import { motion } from "framer-motion";

export const WhoWeAre = () => (
  <section data-testid="who-we-are-section" className="bg-baseLight px-6 py-[30px] sm:py-[40px] lg:px-12 lg:py-[80px]">
    <div className="lg:mx-auto lg:max-w-[1280px]">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6 }}
        className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-16"
      >
        <div className="lg:col-span-5">
          <h2
            data-testid="who-we-are-headline"
            className="font-heading text-[28px] font-semibold leading-tight text-ink sm:text-[32px] lg:text-[36px]"
          >
            An integrator, not
            <br className="sm:hidden" /> a component manufacturer
          </h2>
        </div>
        <p data-testid="who-we-are-text" className="text-[15px] leading-relaxed text-inkSoft lg:col-span-7 lg:pt-1">
          Off-Grid Hydrogen integrates commercially available energy technologies into
          site-specific agricultural systems. Rather than manufacturing equipment, the company
          coordinates engineering, suppliers and contractors to deliver complete energy
          solutions for BC farms and rural operations facing grid constraints and diesel
          dependence.
        </p>
      </motion.div>
    </div>
  </section>
);
